// A small sample cannot decide the order. The neutral score gives new artists time to collect reviews.
const MIN_REVIEWS = 3;
const NEUTRAL_SCORE = 4;
const PRIOR_REVIEWS = 10;

export function artistRankingScore(artist) {
  const count = Number(artist?.reviews?.count);
  const average = Number(artist?.reviews?.average);
  if (!Number.isFinite(count) || count < MIN_REVIEWS || !Number.isFinite(average) || average < 1 || average > 5) {
    return NEUTRAL_SCORE;
  }
  return (average * count + NEUTRAL_SCORE * PRIOR_REVIEWS) / (count + PRIOR_REVIEWS);
}

export function sortArtistsByReviews(artists = []) {
  // Preserve Studio order when the evidence is tied; never mutate the API result.
  return [...artists].sort((a, b) => artistRankingScore(b) - artistRankingScore(a));
}
